import { zql } from '../../schema.js';
/**
 * Doses, protocol doses and dose limits are stored without a unit, so once a prescription or protocol
 * uses a substance its dose unit can't change: 100 mg would be read as 100 g (CY-369).
 * Server-only: the client cache may not hold every prescription.
 */
export async function assertDoseUnitUnlocked(tx, params) {
    const { substanceId, substanceName, previousUnitId, nextUnitId } = params;
    if (tx.location !== 'server')
        return;
    if (nextUnitId === undefined || (previousUnitId ?? null) === (nextUnitId ?? null))
        return;
    const [prescription, protocol] = await Promise.all([
        tx.run(zql.patientTherapySequenceMedicine
            .where('activeSubstanceId', '=', substanceId)
            .where('deletedAt', 'IS', null)
            .whereExists('therapySequence', sequence => sequence.where('deletedAt', 'IS', null))
            .one()),
        tx.run(zql.protocolTherapySequenceMedicine
            .where('activeSubstanceId', '=', substanceId)
            .where('deletedAt', 'IS', null)
            .whereExists('therapySequence', sequence => sequence
            .where('deletedAt', 'IS', null)
            .whereExists('protocol', protocol => protocol.where('deletedAt', 'IS', null)))
            .one()),
    ]);
    if (prescription || protocol) {
        throw new Error(`The dose unit of ${substanceName} can't change: it is used in prescriptions or protocols`);
    }
}
//# sourceMappingURL=dose-unit-lock.js.map